import dayjs from "dayjs"
import { get, isEmpty } from "lodash"
import { useMemo } from "react"
import { useMutation } from "react-query"
import { HbDeal, SendMsgDto } from "../api/HbDeal"
import { TChannel } from "../shared/types/Channel.type"
import { useAuth } from "./useAuth"

export const useOnboarding = () => {

    const { auth } = useAuth()
    const getDealId = useMutation(({ dealId, userId }: { dealId: number, userId: number }) => HbDeal.getDealById(userId, dealId))

    const createGroup = useMutation(({ numbers, groupName }: { numbers: string[], groupName: string }) => HbDeal.createGroup(numbers, groupName))

    const saveGroupChannel = useMutation((data: Partial<TChannel>) => HbDeal.saveWhatsappGroupChannel(data))

    const previewWaMessage = useMutation((data: { text: string, user: string }) => HbDeal.previewMessage(data))
    const sendWaMessage = useMutation((data: SendMsgDto) => HbDeal.sendWaMessage(data))

    const getLatestHubspotId = useMemo(() => {
        if (!auth?.id) return null

        let deals = auth?.hubspot_deals ?? []

        if (isEmpty(deals)) return null

        const sorted = [...deals].sort((a, b) =>
            dayjs(b.created_at).valueOf() - dayjs(a.created_at).valueOf()
        )

        return sorted[0]?.hubspot_id

    }, [auth?.id])

    return {
        getDealId,
        createGroup,
        saveGroupChannel,
        previewWaMessage,
        sendWaMessage,
        getLatestHubspotId
    }

}